export default __webpack_public_path__ + "static/1-5-2-2-f3c7efc7f48e5b6c4c0726db4e539e35.jpg";